import { Component, Input } from '@angular/core';
import { StylePropertyInterface } from 'src/app/wagtail-page/elements/two-lan/two-lan.component';
import { ProductBadgeInterface } from "@gea-waldviertler-website/gea-models";

@Component({
    selector: 'gea-shop-product-item-badge',
    templateUrl: './item-badge.component.html',
    styleUrls: ['./item-badge.component.scss'],
    standalone: false
})
export class ItemBadgeComponent {

  @Input() badge?: ProductBadgeInterface

  constructor() {

  }

  getStyles(): StylePropertyInterface {
    let styles: StylePropertyInterface = {}

    if(! this.badge) return styles
    
    styles['color'] = this.badge.textColor
    styles['background-color'] = this.badge.backgroundColor

    return styles
  }

}
